import {
   InteractiveTable,
   InteractiveTableCellProps,
   StyledFlex,
   UncontrolledCheckbox,
} from '@dreryk/react-components';

import { interactiveTableKeys } from '../../../../translations';
import { BodySide } from '../DiagnosesWithBodySideInteractiveTable.types';

type BodySideCellProps = InteractiveTableCellProps<BodySide>;

export const BodySideCell = (props: BodySideCellProps): JSX.Element => {
   return (
      <InteractiveTable.CustomCell<BodySide>
         testId={props.name}
         name={props.name}
         index={props.index}
         defaultValue={props.defaultValue}
      >
         {(value, onChange) => {
            const handleSelectionChange = (selection: boolean, id: string): void => {
               onChange({
                  ...value,
                  [id]: selection,
               });
            };
            return (
               <StyledFlex gap={'12px'}>
                  <UncontrolledCheckbox
                     testId={'left'}
                     name={'left'}
                     id={'left'}
                     onSelectionChange={handleSelectionChange}
                     selected={value.left}
                     label={interactiveTableKeys.cells.bodySide.left.label}
                  />
                  <UncontrolledCheckbox
                     testId={'right'}
                     name={'right'}
                     id={'right'}
                     onSelectionChange={handleSelectionChange}
                     selected={value.right}
                     label={interactiveTableKeys.cells.bodySide.right.label}
                  />
               </StyledFlex>
            );
         }}
      </InteractiveTable.CustomCell>
   );
};
